import { FC, PropsWithChildren, useState } from "react";
import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const text = "Нажимая на кнопку вы подтверждаете, что хотите принять участие в этом событии."

export interface  AlertProps {
  onSuccess: () => void
  onCancel: () => void
  isLoading: boolean
}
export const Alert: FC<PropsWithChildren<AlertProps>> = ({ onSuccess, onCancel, isLoading}) => {
  return <>
    <DialogTitle>
      Подтверждение
    </DialogTitle>
    <DialogContent>
      {isLoading ? <CircularProgress color="secondary" /> : text}
    </DialogContent>
    <DialogActions>
      <Button variant="text" onClick={onCancel}>
        назад
      </Button>
      <Button variant="contained" disabled={isLoading} onClick={onSuccess}>
        Подтвердить
      </Button>
    </DialogActions>
  </>
}